import { SourcingAutomatedAction } from 'api-clients/monolith';
import { useIntl } from 'react-intl';

import { LightningBoltIcon } from '@/components/icons/lightning-bolt';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

interface AutomationActionPillProps {
  action: SourcingAutomatedAction['action'];
}

export function AutomationActionPill({ action }: AutomationActionPillProps) {
  const intl = useIntl();
  const messages = {
    resume: intl.formatMessage({
      defaultMessage: 'Sourcing automatically resumed',
      description:
        'Funnel stage badge: automation rule turned channel spend back on',
    }),
    pause: intl.formatMessage({
      defaultMessage: 'Sourcing automatically paused',
      description:
        'Funnel stage badge: automation rule stopped spend on a channel',
    }),
  };

  return (
    <div className="bg-fx-brand-50 align-items-center flex gap-2 whitespace-nowrap rounded-sm px-2 py-1.5">
      <LightningBoltIcon className="text-fx-primary h-4 w-4" />
      <Typography variant="body1" className="!text-fx-neutral-900">
        {messages[action]}
      </Typography>
    </div>
  );
}

AutomationActionPill.Skeleton = function AutomationActionPillSkeleton() {
  return (
    <div className="bg-fx-brand-50 flex h-6 w-fit place-items-center justify-center gap-1 whitespace-nowrap rounded-full pl-2 pr-3">
      <LightningBoltIcon className="text-fx-primary h-4 w-4" />
      <Skeleton className="h-4 w-4" />
    </div>
  );
};
